import './image_view.css';

const ImageView = ({ title = "Image View", url, onClose }) => {
  return (
    <div id="image_view">
      <div className="head">
        <h1>{title}</h1>
      </div>
      <div className="body">
        {url && (
          <img 
            src={url} 
            alt={title}
            style={{ 
              maxWidth: '100%', 
              maxHeight: '100%', 
              objectFit: 'contain' 
            }}
          />
        )}
      </div>
      <div className="foot">
        <button onClick={() => onClose()}>닫기</button>
      </div>
    </div>
  );
};

export default ImageView;
